import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import { setupCalendar } from 'v-calendar';

import App from './App.vue';
import router from './router';
import i18n from './i18n';

// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'element-plus/dist/index.css';
import 'v-calendar/dist/style.css';
import './assets/style.css';
import './assets/css/tables.css';
import './assets/css/forms.css';
import './assets/css/buttons.css';
import './assets/css/badges.css';
import './assets/css/views.css';
import './plugins/axios';
import { vNumeric } from './directives/vNumeric';

const app = createApp(App);
app.directive('numeric', vNumeric);
const pinia = createPinia();
const calendarConfig = {
  locale: 'pt-BR',
  firstDayOfWeek: 1,
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'WWW',
    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
  }
};

// Pinia must be registered before router so that stores used in navigation guards are available
app.use(pinia);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(setupCalendar, calendarConfig);

app.config.errorHandler = (err, instance, info) => {
  console.error('[SisGel] Erro global:', err, info)
}

app.mount('#app');